
  import {
    mapSectionComponents,
    replaceActivityDataInSections,
    replaceCityDataInSections,
  } from '@/helper/SectionHelper';
  import {
    getMetaTags,
    replaceActivityDataInMetaData,
    replaceCityDataInMetaData,
  } from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'LandingPageCitiesCity',
    components: {
      LazyHydrate,
    },
    async asyncData({app, route, error, $cachedStrapi}) {
      const pagePromise = $cachedStrapi
        .findOne('pages', 'landingpages-cities-city-activity')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const cityPromise = $cachedStrapi
        .findOne('cities', route.params.city)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const activityPromise = $cachedStrapi
        .findOne('activities', route.params.activity)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const [page, city, activity] = await Promise.all([
        pagePromise,
        cityPromise,
        activityPromise,
      ]);

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }
      if (!scopeHelper(city, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'City not found'});
        return;
      }
      if (!scopeHelper(activity, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Activity not found'});
        return;
      }

      // Map section components and replace city data/placeholder
      let sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.landingpage_cities'),
                  disabled: false,
                  to: app.localePath({
                    name: 'landingpages-cities',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: city.title,
                  disabled: false,
                  to: app.localePath({
                    name: 'landingpages-cities-city',
                    params: {
                      city: city.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: activity.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'landingpages-cities-city-activity',
                    params: {
                      activity: activity.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                activity.seo_content_config &&
                activity.seo_content_config.seo_contents &&
                activity.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  activity.seo_content_config.seo_contents[0].id
                );
              } else if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );
      sections = replaceActivityDataInSections(sections, activity);
      sections = replaceCityDataInSections(sections, city);

      let metaData = replaceCityDataInMetaData(page.meta ?? {}, city);
      metaData = replaceActivityDataInMetaData(metaData, activity);

      return {
        metaData,
        sections,
        city,
        activity,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
        city: {},
        activity: {},
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
